module.exports = __webpack_public_path__ + "img/empty.ae9bf73e.png";